import { h } from '../pragma.mjs';

export default () => {

    return (
        <div>

            <gov-breadcrumbs wcag-label="Úroveň zanoření v rozcestníku">
                <ul class="breadcrumbs">
                    <li><gov-icon type="basic" name="chevron-right"></gov-icon><a id="rozcestnikRoot" href="#">Domů</a></li>
                    <li><gov-icon type="basic" name="chevron-right"></gov-icon><a id="rozcestnikZapisy" href="#">Zápisy</a></li>
                    <li><gov-icon type="basic" name="chevron-right"></gov-icon><a id="rozcestnikDalsi" href="#">Další ...</a></li>
                    <li><gov-icon type="basic" name="chevron-right"></gov-icon><strong>Body polohového pole</strong></li>
                </ul>
            </gov-breadcrumbs>
            
            <gov-tiles role="list">
                {/* <gov-tile role="listitem" class="gray_card" id="toastZamerZnacka" href="#">
                    <p>Byl mi sdělen záměr o umístění značky bodu podrobného polohového bodového pole</p>
                    <h3 slot="title">Záměr o umístění značky</h3>
                    <gov-icon type="complex" name="doc-basic-info" slot="icon"></gov-icon>
                </gov-tile> */}
                <gov-tile role="listitem" id="rozcestnikDalsi2S8008" href="#">
                    <p>Chci ohlásit závadu v geodetických údajích bodů bodových polí.</p>
                    <h3 slot="title">Oznámení změn a zjištěných závad v údajích o bodu bodového pole</h3>
                    <gov-icon type="complex" name="map" slot="icon"></gov-icon>
                </gov-tile>             
            </gov-tiles>
        </div>
    )

}